import { errorlog } from '@/libs/error-logs';
import { toast_error } from '@/libs/toast-wrappers';
import { toError } from '@/utils/errors';

import { GET, POST, PATCH, DELETE } from './base/index';
import { ENDPOINTS } from './endpoints';
import { StandardResponse } from './standard-response';

export type ApiKey = {
  api_key_hash: string;
  name: string;
  status: 'active' | 'disabled';
  created_at: string;
  last_used_at: string | null;
};

export type CreateApiKeyResponse = {
  api_key: string;
  name: string;
  created_at: string;
};

export async function getApiKeysList(email: string): Promise<ApiKey[]> {
  try {
    const response = await GET<StandardResponse<ApiKey[]>>(ENDPOINTS.API_KEYS_LIST, {
      parameters: { email },
    });
    return response.data;
  } catch (error) {
    errorlog(error as Error, 'src/api/api-keys/getApiKeysList', 'Error fetching API keys');
    toast_error('Error fetching API keys. Please try again.');
    return Promise.reject(toError(error));
  }
}

export async function createApiKey(email: string, name: string): Promise<CreateApiKeyResponse> {
  try {
    const response = await POST<StandardResponse<CreateApiKeyResponse>>(
      ENDPOINTS.API_KEYS_CREATE,
      { name },
      { parameters: { email } }
    );
    return response.data;
  } catch (error) {
    errorlog(error as Error, 'src/api/api-keys/createApiKey', 'Error creating API key');
    toast_error('Error creating API key. Please try again.');
    return Promise.reject(toError(error));
  }
}

export async function updateApiKeyStatus(
  keyHash: string,
  status: 'active' | 'disabled'
): Promise<void> {
  try {
    await PATCH<StandardResponse<void>>(
      ENDPOINTS.API_KEYS_UPDATE_STATUS,
      { status },
      { parameters: { keyHash } }
    );
  } catch (error) {
    errorlog(
      error as Error,
      'src/api/api-keys/updateApiKeyStatus',
      'Error updating API key status'
    );
    toast_error('Error updating API key status. Please try again.');
    return Promise.reject(toError(error));
  }
}

export async function deleteApiKey(keyHash: string): Promise<void> {
  try {
    await DELETE<StandardResponse<void>>(ENDPOINTS.API_KEYS_DELETE, {
      parameters: { keyHash },
    });
  } catch (error) {
    errorlog(error as Error, 'src/api/api-keys/deleteApiKey', 'Error deleting API key');
    toast_error('Error deleting API key. Please try again.');
    return Promise.reject(toError(error));
  }
}
